import React, { type ReactNode } from 'react';

import Heading from '@atlaskit/heading';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

export type CarouselSlideProps = {
	heading?: string;
	title?: string;
	children: ReactNode;
};

const containerStyles = xcss({
	height: '100%',
});

const headingStyles = xcss({
	textAlign: 'center',
});

const childrenStyles = xcss({
	overflowY: 'auto',
	width: '100%',
	flexGrow: 1,
	height: '100%',
});

const titleStyles = xcss({
	font: token('font.heading.medium'),
	fontWeight: token('font.weight.regular'),
	textAlign: 'center',
	// Remove the automatic margin applied to p tags.
	marginTop: 'space.0',
});

export const CarouselSlide = ({ heading, children, title }: CarouselSlideProps) => (
	<Stack
		space="space.200"
		alignInline="center"
		xcss={containerStyles}
		testId="growth-pattern-library-modal-carousel-slide"
	>
		{heading ? (
			<Box xcss={headingStyles}>
				<Heading as="span" size="small">
					{heading}
				</Heading>
			</Box>
		) : null}
		<Box xcss={childrenStyles}>{children}</Box>
		{title ? (
			<Box as="p" xcss={titleStyles}>
				{title}
			</Box>
		) : null}
	</Stack>
);
